// Currency switcher (modules/currency): click toggles the panel, Escape and
// outside clicks close it. Hover and keyboard focus are handled in CSS.

function bindCurrencySwitcher(root) {
    if (root.dataset.sonCurrencyReady) {
        return;
    }
    root.dataset.sonCurrencyReady = 'true';

    const toggle = root.querySelector('.son-currency-switcher__toggle');

    // the header version grows the box by exactly the list's height (see the SCSS)
    const list = root.querySelector('.son-currency-switcher__menu ul');
    if (list) {
        const measure = () => root.style.setProperty('--son-currency-list-h', `${list.offsetHeight}px`);
        new ResizeObserver(measure).observe(list);
        measure();
    }
    const setOpen = (open) => {
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    toggle.addEventListener('click', () => setOpen(!root.classList.contains('is-open')));
    root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            setOpen(false);
            toggle.focus();
        }
    });
    document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) {
            setOpen(false);
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.son-currency-switcher').forEach(bindCurrencySwitcher);
});
